<template lang='pug'>
div.items-builder
  el-table(:data='nonTaxItems')

    //- el-table-column(label='Pos.', prop='position')
    el-table-column(label='Qty', width='105px')
      template(slot-scope='scope')
        el-input-number(
          v-model='scope.row.quantity', :min='1', size='mini',
          v-if='hasVariableQuantity(scope.row.type)')

    el-table-column(prop='name', label='Name')
      template(slot-scope='scope')
        el-input(v-model='scope.row.name', v-if='scope.row.type == "CUSTOM"', size='mini')
        template(v-else)
          | {{scope.row.name}} &nbsp;
          i.mat-icon(v-if='scope.row.type == "DELIVERY"') motorcycle

    el-table-column(label='Unit price', width='115px')
      template(slot-scope='scope')
        el-input(
          v-if='scope.row.type == "CUSTOM"',
          v-model='customPrice', size='mini'
        )
          template(slot='prepend')
            | $
        template(v-else)
          | {{$formatCents(scope.row.sale_price_cents) }}

    el-table-column(label='Price', width='95px')
      template(slot-scope='scope')
        | {{$formatCents(scope.row.sale_price_cents*scope.row.quantity) }}

  .numeric-summary
    .label Subtotal
    .value {{$formatCents(subtotalCents)}}
  .numeric-summary
    .label Tax | {{(taxRate*100).toFixed(1)}}%
    .value {{$formatCents(taxValue)}}
  .numeric-summary
    .label Total
    .value {{$formatCents(totalCents)}}
</template>

<style lang='sass'>
.items-builder
  .el-input-number--mini
    max-width: 95px
  .el-input-group__prepend
    // this is the dollar sign
    padding: 0 8px
  .el-input-group--prepend
    // this is the whole group with dollar + input included
    max-width: 115px
</style>


<script>
import _ from 'underscore'
import Vue from 'vue'

function defaultItems () {
  return {
    TAX: { type: 'TAX', quantity: 1, checked: true, sale_price_cents: 0, name: 'Tax', position: 0 },
  }
}

function data(){
  return {
    indexedItems: defaultItems()
  }
}

function created(){
  // TODO add all this event handlers at the parent?
  // that way hot reload doesn't break things
  // because these events are not replicated after the reload
  // but if they were data on the parent the value would remain after
  // hot reloading hence removing the issue
  this.eventBus.$on("add_item", this.addItem)
  this.eventBus.$on("remove_item", this.removeItem)
  this.eventBus.$on("reset_items", this.resetItems)
  this.eventBus.$emit("resend_all_items")
}

// function refreshCustomPrice(newVal, oldVal){
//   const newPrice = parseFloat(newVal)
//   if (isNaN(newPrice)){
//     // Invalid input was given
//
//   }
//   console.log("***CUSTOM", newVal, oldVal)
//   // const item = this.indexedItems[type]
//   // if (isNaN(parseFloat(item.sale_price_dollars))) return
//   // item.sale_price_cents = item.sale_price_dollars * 100
// }

// // Given the type of item, calculates what the given position should be
// function newPosition(type){
//   switch(type){
//       case 'PRODUCT':
//         return _.size(this.productItems)
//       case 'TAX':
//         return _.size(this.indexedItems)
//       case 'DELIVERY':
//         return _.size(this.productItems)+1
//       case 'CUSTOM':
//         return _.size(this.productItems)//+1
//   }
// }

function addItem(id, item){
  console.log("ADDING ITEM WITH POS", item, item.position)
  const finalItem = Object.assign({},item, {
    sale_price_dollars: item.sale_price_cents/100,
    position: (item.position || _.size(this.indexedItems)),
    index: id
  })
  this.$set(this.indexedItems, id, finalItem)
  // this.indexedItems.TAX.position = _.size(this.indexedItems)
  this.refreshPositions()
}

function removeItem(id){
  this.$delete(this.indexedItems, id)
  this.refreshPositions()
}

function resetItems(){
  this.indexedItems = defaultItems()
}

function nonTaxItems () {
  // let itemOrder = (i) => {
  //   switch(i.type){
  //       case 'PRODUCT':
  //         return 1
  //       case 'TAX':
  //         return 4
  //       case 'DELIVERY':
  //         return 3
  //       case 'CUSTOM':
  //         return 2
  //   }
  // } // itemOrder
  return _.chain(this.indexedItems).values()
    .reject( (i) => i.type == 'TAX'|| i.deleted ).sortBy( (i) => i.position ).value()
}

function productItems(){
  return _.chain(this.indexedItems).values().filter( (i) => i.type == 'PRODUCT' ).value()
}

// Everything but tax & delivery that are dynamic values
function staticItems() {
  return _.reject(_.values(this.indexedItems), (i)=>{
    return i.type == 'TAX' || i.type == 'DELIVERY' || i.deleted
  })
}

function staticItemsTotalCents () {
  return _.reduce(this.staticItems, (subtotal, item)=>{
    return subtotal + (item.quantity * item.sale_price_cents)
  }, 0)
}

function deliveryTotalCents () {
  const delivery = this.indexedItems['DELIVERY']
  if ( delivery == undefined ) return 0
  return delivery.sale_price_cents
}

// If there's delivery, get the static items total and determine the delivery
function calculateDelivery () {
  console.log("Calculating delivery")
  const deliveryItem = this.indexedItems['DELIVERY']
  if ( deliveryItem == undefined ) return 0
  // TODO detect if velidery should be applied
  // 10% of the items
  const applicableDelivery = Math.ceil(this.staticItemsTotalCents * 0.1)
  // 29 USD is the minimum
  const minimumDelivery = 29*100;
  if (applicableDelivery < minimumDelivery){
    deliveryItem.sale_price_cents = minimumDelivery
  }else{
    deliveryItem.sale_price_cents =  applicableDelivery
  }
}

function calculateTax () {
  const taxItem = this.indexedItems['TAX']
  if ( taxItem == undefined ) return 0
  taxItem.sale_price_cents = Math.ceil(this.subtotalCents * this.taxRate)
}

function taxValue () {
  const taxItem = this.indexedItems['TAX']
  if ( taxItem == undefined ) return 0
  return taxItem.sale_price_cents
}

function subtotalCents () {
  return this.staticItemsTotalCents + this.deliveryTotalCents
}

function totalCents () {
  return  _.chain(this.indexedItems).values().reduce( (memo, i) => {
    return memo + (i.sale_price_cents * i.quantity)
  },0).value()
}

function hasVariableQuantity(type) {
  return !(type == 'TAX' || type == 'DELIVERY')
}

const customPrice = {
  get: function(){
    return this.indexedItems.CUSTOM.sale_price_cents / 100
  },
  set: function (newVal) {
    const newPrice = parseFloat(newVal)
    if (isNaN(newPrice)){
      this.indexedItems.CUSTOM.sale_price_cents = 0
    }else{
      this.indexedItems.CUSTOM.sale_price_cents = Math.ceil(newPrice*100)
    }
  }
}

function buildItemsForSubmit(){
  const clonedItems = _.map(
    _.values(this.indexedItems), (i) => { return Object.assign({},i) }
  )
  const [products, fees] = _.partition(
    clonedItems, (i) => { return i.type == 'PRODUCT' }
  )
  const finalProducts = _.map(products, (p) => {
    return {
      product_id: p.product_id,
      quantity: p.quantity,
      type: "PRODUCT",
      position: p.position
    }
  })
  const finalFees = _.map(fees, (f) => {
    return {
      name: f.name,
      quantity: f.quantity,
      sale_price_cents: f.sale_price_cents,
      type: f.type,
      position: f.position
    }
  })
  return finalProducts.concat(finalFees)
}


const computed = {
  staticItems,
  staticItemsTotalCents,
  deliveryTotalCents,
  subtotalCents,
  totalCents,
  productItems,
  nonTaxItems,
  customPrice,
  taxValue,

}

function refreshPositions(){
  if(this.indexedItems.DELIVERY && this.indexedItems.CUSTOM){
    this.indexedItems.DELIVERY.position = _.size(this.indexedItems)
  }
  this.indexedItems.TAX.position = _.size(this.indexedItems)
  
  _.chain(this.indexedItems).pairs().sortBy( (p) => {p[1].position} ).each(
    (p, index) => {
      if(p[1].type=='PRODUCT'){
        this.indexedItems[ p[0] ].position = index
      }
    }
  )
}


const props = {
  estimateId: { required: true },
  eventBus: { required: true },
  taxRate: { required: true }
}

const watch = {
  indexedItems: {
    handler: function(newItems){
      this.calculateDelivery()
      this.calculateTax()
    },
    deep: true
  },
  taxRate: function(newRate){
    this.calculateTax()
  },
  totalCents: function(newValue){
    console.log("SENDING TOTAL", newValue)
    this.$emit('change', newValue)
  }
}

const methods = {
  addItem, removeItem, resetItems, hasVariableQuantity,
  calculateDelivery, calculateTax, buildItemsForSubmit,
  refreshPositions
}

export default { data, methods, props, watch, created, computed }
</script>



// WEBPACK FOOTER //
// src/staff/blocks/ItemsBuilder.vue